<!-- Loading State -->
<div class="loading-container" *ngIf="isLoading && !isTranslationLoaded">
  <qai-loading size="medium"></qai-loading>
</div>
<div class="practice-tab" *ngIf="isTranslationLoaded">
  <div class="header-wrapper">
    <div class="header-section">
      <p>{{ "reportingV2.RESULTS_DESCRIPTION" | transloco }}</p>
      <div class="assignment-selector">
        <app-assignment-filter [assignmentType]="'practice'" (assignmentTypeChange)="onAssignmentChange($event)"></app-assignment-filter>
      </div>
    </div>

    <!-- Empty State -->
    <div
      *ngIf="
        !isLoading &&
        !isNetworkCallInprogress &&
        practiceAssignmentStats.length === 0
      "
      class="empty-container"
    >
      <p>{{ "reportingV2.NO_ASSIGNMENTS_MATCH_FILTERS" | transloco }}</p>
    </div>

    <!--******************** COMMENTED FOR NOW, WILL BE USED IN FUTURE ************-->

    <!-- <div class="benchmarks-section">
      <qai-reporting-card [title]="('reportingV2.USERS_ENGAGED_LABEL' | transloco)"
        [description]="{value: '82%', text: ('reportingV2.HIGHER_THAN_LABEL' | transloco), benchmark: '96%'}"
        [value]="'89%'" [tooltip]="{icon: 'help-circle', content: ('reportingV2.ENGAGED_TOOLTIP' | transloco)}"
        [status]="'success'">
      </qai-reporting-card>

      <qai-reporting-card [title]="('reportingV2.SESSIONS_PER_ACTIVE_USERS_LABEL' | transloco)"
        [description]="{value: '12%', text: ('reportingV2.MORE_THAN_LABEL' | transloco), benchmark: '56%'}" [value]="8"
        [status]="'warning'"></qai-reporting-card>

      <qai-reporting-card [title]="('reportingV2.TOTAL_SESSIONS_COMPLETED_LABEL' | transloco)"
        [value]="'1418'"></qai-reporting-card>
    </div> -->
  </div>

  <div class="loading-container" *ngIf="isNetworkCallInprogress">
    <qai-loading size="medium"></qai-loading>
  </div>

  <ng-container *ngIf="practiceAssignmentStats.length !== 0 && !isNetworkCallInprogress">
    <app-practice-chart [practiceAssignmentStats]="visiblePracticeAssignments"></app-practice-chart>
    
    <app-practice-table [practiceAssignmentStats]="practiceAssignmentStats"
      (visibleAssignmentsChanged)="onVisibleAssignmentsChanged($event)"></app-practice-table>
  </ng-container>
</div>
